import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import History from "../../components/history";
import { Table, Row, Col, Form, Button } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { useCookies } from "react-cookie";
import Notifications, { notify } from "react-notify-toast";
import axios from "axios";
import styles from "./Resultados.module.css";

const physicalIndicators = [
  { key: "precipitacionPeriodo", label: "Precipitación Periodo (mm.)" },
  { key: "areaUtilPromHa", label: "Area Util. (Prom. ha)" },
  { key: "stockCabPromAno", label: "Stock Cab. (Prom. Año)" },
  { key: "ugPromAno", label: "U.G. (Prom. Año)" },
  { key: "cargaCabHaPromAno", label: "Carga Cab./Ha (Prom. Año)" },
  { key: "cargaUgHaPromAno", label: "Carga U.G./Ha (Prom. Año)" },
  { key: "cargaKgsHaPromAno", label: "Carga Kgs./Has (Prom. Año)" },
  { key: "totalKilosProducidos", label: "Total de Kilos Producidos" },
  { key: "produccionKgsHaAno", label: "Produccion de Kgs./Ha/Año" },
  { key: "produccionKgsCabAno", label: "Produccion por Cab/año (kg)" },
  { key: "produccionKgsUgAno", label: "PRODUCCION KGS./U.G./AÑO" },
  { key: "gdpKgsCabDia", label: "GDP (Kgs./cab./día)" },
  {
    key: "totalCabVendidasConsumidasDonadas",
    label: "Total cab. Vendidas,Consumidas,Donadas",
  },
  { key: "porcentajeExtraccion", label: "% de Extracción" },
  { key: "porcentajeMortandad", label: "% de Mortandad" }
];

const reproductiveIndicators = [
  { key: "totalHembrasServicio", label: "Total Hembras en Servicio" },
  { key: "toros", label: "Toros" },
  { key: "porcentajeToros", label: "% de Toros" },
  { key: "totalHembrasPrenhadas", label: "Total Hembras Preñadas" },
  { key: "porcentajePrenesGeneral", label: "% Preñez General" },
  { key: "porcentajeHembrasExpCabPromAno", label: "% de Hembras exp sobre Cab./Prom./Año" },
  {
    key: "porcentajeExtraccionVientres",
    label: "% de Extraccion de Vientres",
  },
  {
    key: "porcentajeReposicionVientres",
    label: "% De Reposicion de Vientres",
  },
  { key: "totalTernerosMarcados", label: "Total de Terneros marcados" },
  { key: "porcentajeMarcacion", label: "% Marcacion" },
  { key: "porcentajeMerma", label: "% Merma" },
  {
    key: "pesoPromedioDesteteMacho",
    label: "Peso promedio destede (Macho) Kg.",
  },
  {
    key: "pesoPromedioDesteteHembra",
    label: "Peso promedio destete (Hembra) Kg.",
  },
];

const allIndicators = [...physicalIndicators, ...reproductiveIndicators];

const initialFormState = allIndicators.reduce((acc, item) => {
  acc[item.key] = "";
  return acc;
}, {});


const Resultados = (props) => {
  const { embedded = false, year: propYear } = props;
  const [cookie] = useCookies(["kUserSession"]);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [year, setYear] = useState(propYear ?? new Date().getFullYear());

  const [formData, setFormData] = useState(initialFormState);
  const [periodOpen, setPeriodOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [resultId, setResultId] = useState(null);

  const history = [
    { name: "Inicio", path: "/" },
    { name: "Movimientos de hacienda", path: "/movimientos" },
  ];

  const prepareHeaders = () => {
    return {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        api_key: "k-randa",
        access_token: cookie.kUserSession.data.access_token,
      },
    };
  };

  const retrieve = () => {
    setLoading(true);
    // Clean previous results to avoid duplicated periods while loading
    setResults([]);
    setFormData(initialFormState);
    const currentFarm = cookie.kUserSession.data["farm"];
    const url =
      "resultados-indices?periodo=" + year + "&id_estancia=" + currentFarm.id;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          const ordered = [...rs.data].sort(
            (a, b) => a.periodo - b.periodo
          );
          setResults(ordered);
          const current = ordered.find((item) => item.periodo == year) || {};
          const filled = { ...initialFormState };
          allIndicators.forEach((item) => {
            filled[item.key] = current[item.key] ?? "";
          });
          setFormData(filled);
          setResultId(current.id || undefined);
        } else {
          setResults([]);
          setFormData(initialFormState);
          setResultId(undefined);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setResults([]);
        setFormData(initialFormState);
        setResultId(undefined);
        setLoading(false);
      });
  };

  const retrievePeriodo = () => {
    const currentFarm = cookie.kUserSession.data["farm"];
    const url = `periodos/${year}/${currentFarm.id}`;
    axios
      .get(process.env.REACT_APP_API_URL + url, prepareHeaders())
      .then((rs) => {
        if (rs.status === 200) {
          setPeriodOpen(rs.data?.estado === "ABIERTO");
        } else {
          setPeriodOpen(false);
        }
      })
      .catch(() => setPeriodOpen(false));
  };

  const confirm = () => {
    const currentFarm = cookie.kUserSession.data["farm"];
    const payload = {
      periodo: year,
      idEstancia: currentFarm.id,
    };
    allIndicators.forEach((item) => {
      const value = formData[item.key];
      payload[item.key] = value === "" ? null : Number(value);
    });

    setLoading(true);
    const current = results.find((r) => r.periodo === year);
    const request = current && current.id
      ? axios.put(
          process.env.REACT_APP_API_URL + "resultados-indices/" + current.id,
          payload,
          prepareHeaders()
        )
      : axios.post(
          process.env.REACT_APP_API_URL + "resultados-indices",
          payload,
          prepareHeaders()
        );

    request
      .then(() => {
        retrieve();
        setEditing(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const cancel = () => {
    const current = results.find((item) => item.periodo == year) || {};
    const filled = { ...initialFormState };
    allIndicators.forEach((item) => {
      filled[item.key] = current[item.key] ?? "";
    });
    setFormData(filled);
    setEditing(false);
  };

  const deleteResult = () => {
    if (!resultId) return;
    axios
      .delete(
        process.env.REACT_APP_API_URL + `resultados-indices/${resultId}`,
        prepareHeaders()
      )
      .then(() => {
        notify.show("Resultado eliminado", "success");
        retrieve();
      })
      .catch((err) => {
        console.error(err);
        notify.show("Ocurrió un error al eliminar", "error");
      });
  };

  const handleValueChange = (key, v) => {
    const updated = { ...formData, [key]: v.value };
    if (key === "areaUtilPromHa") {
      const area = v.floatValue;
      const totalKilos = parseFloat(updated.totalKilosProducidos);
      const ugPromAno = parseFloat(updated.ugPromAno);
      const stockCabPromAno = parseFloat(updated.stockCabPromAno);

      updated.produccionKgsHaAno = (!isNaN(area) && area !== 0 && !isNaN(totalKilos)) ? (totalKilos / area).toFixed(2) : 0;
      updated.produccionKgsCabAno = (!isNaN(stockCabPromAno) && stockCabPromAno !== 0 && !isNaN(totalKilos)) ? (totalKilos / stockCabPromAno).toFixed(2) : 0;
      updated.produccionKgsUgAno = (!isNaN(ugPromAno) && ugPromAno !== 0 && !isNaN(totalKilos)) ? (totalKilos / ugPromAno).toFixed(2) : 0;

      updated.cargaCabHaPromAno = (!isNaN(area) && area !== 0 && !isNaN(stockCabPromAno)) ? (stockCabPromAno / area).toFixed(2) : 0;
      updated.cargaUgHaPromAno = (!isNaN(area) && area !== 0 && !isNaN(ugPromAno)) ? (ugPromAno / area).toFixed(2) : 0;
      updated.cargaKgsHaPromAno = (!isNaN(updated.cargaUgHaPromAno) ? ((ugPromAno / area) * 400).toFixed(2) : 0);
    }
    if(key == "stockCabPromAno"){

      const stockCabPromAno = v.floatValue;      
      const totalKilos = parseFloat(updated.totalKilosProducidos);
      const ugPromAno = parseFloat(updated.ugPromAno);
      const area = parseFloat(updated.areaUtilPromHa);

      updated.produccionKgsHaAno = (!isNaN(area) && area !== 0 && !isNaN(totalKilos)) ? (totalKilos / area).toFixed(2) : 0;
      updated.produccionKgsCabAno = (!isNaN(stockCabPromAno) && stockCabPromAno !== 0 && !isNaN(totalKilos)) ? (totalKilos / stockCabPromAno).toFixed(2) : 0;
      updated.produccionKgsUgAno = (!isNaN(ugPromAno) && ugPromAno !== 0 && !isNaN(totalKilos)) ? (totalKilos / ugPromAno).toFixed(2) : 0;

      updated.cargaCabHaPromAno = (!isNaN(area) && area !== 0 && !isNaN(stockCabPromAno)) ? (stockCabPromAno / area).toFixed(2) : 0;
      updated.cargaUgHaPromAno = (!isNaN(area) && area !== 0 && !isNaN(ugPromAno)) ? (ugPromAno / area).toFixed(2) : 0;
      updated.cargaKgsHaPromAno = (!isNaN(updated.cargaUgHaPromAno) ? ((ugPromAno / area) * 400).toFixed(2) : 0);      

      updated.gdpKgsCabDia = (!isNaN(stockCabPromAno) && stockCabPromAno !== 0 && !isNaN(totalKilos)) ? (totalKilos / stockCabPromAno / 365).toFixed(2) : 0;

    }
    setFormData(updated);
  };

  useEffect(() => {
    retrieve();
    retrievePeriodo();
  }, []);

  useEffect(() => {
    if (propYear !== undefined) {
      setYear(propYear);
    }
  }, [propYear]);

  useEffect(() => {
    retrieve();
    retrievePeriodo();
    setEditing(false);
  }, [year]);

  return (
    <>
      <Notifications />
      {!embedded && <Header history={props.history} />}
      <section className={styles.body}>
        {!embedded && (
          <Row>
            <Col>
              <History
                items={history}
                current={"Resultados"}
                history={props.history}
              />
            </Col>
          </Row>
        )}
        <Row>
          {!embedded && (
            <Col md={2} xs={12}>
              <section className={styles.side}>
                <Form className={styles.searchForm}>
                  <Form.Group>
                    <Form.Label htmlFor="periodo" className={styles.label}>
                      Periodo
                    </Form.Label>
                    <NumericFormat
                      id="periodo"
                      className="karanda-input"
                      customInput={Form.Control}
                      value={year}
                      onValueChange={(v) => setYear(v.floatValue ?? 0)}
                      allowNegative={false}
                      decimalSeparator="," 
                      thousandSeparator="."
                      decimalScale={0}
                    />
                  </Form.Group>
                </Form>
              </section>
            </Col>
          )}
          <Col>
            <section className={styles.content}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <h1 className={styles.title} style={{ marginBottom: 0 }}>
                  Resultados periodo {year - 1}/{year}
                </h1>
                {resultId && periodOpen && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={deleteResult}
                  >
                    Eliminar
                  </Button>
                )}
              </div>
              {loading ? (
                <span>Cargando...</span>
              ) : (
                <Form>
                  <Table bordered hover responsive className="karanda-table">
                    <thead>
                      <tr>
                        <th>EFICIENCIA FÍSICA</th>
                        {results.map((r) => (
                          <th key={r.periodo}>{r.periodo}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {physicalIndicators.map((item) => (
                        <tr key={item.key}>
                          <td>{item.label}</td>
                          {results.map((r) => (
                            <td key={r.periodo}>
                              {r.periodo == year && (editing || !resultId) ? (
                                <NumericFormat
                                  className="karanda-input karanda-input-small"
                                  value={formData[item.key]}
                                  customInput={Form.Control}
                                  name={item.key}
                                  disabled={!["stockCabPromAno", "areaUtilPromHa"].includes(item.key)}
                                  thousandSeparator="."
                                  decimalSeparator="," 
                                  decimalScale={2}
                                  allowNegative={false}
                                  onValueChange={(v) =>
                                    handleValueChange(item.key, v)
                                  }
                                />
                              ) : (
                                <NumericFormat
                                  value={r[item.key] ?? ""}
                                  displayType="text"
                                  thousandSeparator="."
                                  decimalSeparator="," 
                                  decimalScale={2}
                                  fixedDecimalScale
                                />
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                      <tr className="karanda-header-tr">
                        <th>EFICIENCIA REPRODUCTIVA</th>
                        {results.map((r) => (
                          <th key={r.periodo}>{r.periodo}</th>
                        ))}
                      </tr>
                      {reproductiveIndicators.map((item) => (
                        <tr key={item.key}>
                          <td>{item.label}</td>
                          {results.map((r) => (
                            <td key={r.periodo}>
                              {r.periodo == year && (editing || !resultId) ? (
                                <NumericFormat
                                  className="karanda-input karanda-input-small"
                                  value={formData[item.key]}
                                  customInput={Form.Control}
                                  name={item.key}
                                  thousandSeparator="."
                                  decimalSeparator="," 
                                  decimalScale={2}
                                  disabled={!["toros"].includes(item.key)}
                                  allowNegative={false}
                                  onValueChange={(v) =>
                                    handleValueChange(item.key, v)
                                  }
                                />
                              ) : (
                                <NumericFormat
                                  value={r[item.key] ?? ""}
                                  displayType="text"
                                  thousandSeparator="."
                                  decimalSeparator="," 
                                  decimalScale={2}
                                  fixedDecimalScale
                                />
                              )}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <div style={{ textAlign: "right" }}>
                    {editing || !resultId ? (
                      <>
                        <Button
                          className="karanda-btn"
                          onClick={confirm}
                          disabled={loading}
                        >
                          Confirmar
                        </Button>
                        <Button
                          className="karanda-btn-outline"
                          onClick={cancel}
                          disabled={loading}
                          style={{ marginLeft: "10px" }}
                        >
                          Cancelar
                        </Button>
                      </>
                    ) : (
                      periodOpen && (
                        <Button
                          className="karanda-btn"
                          onClick={() => setEditing(true)}
                        >
                          Editar
                        </Button>
                      )
                    )}
                  </div>
                </Form>
              )}
            </section>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default Resultados;
